import angular from 'angular';
import template from './app.component.html';
import style from './app.component.css';

export default angular.module('appRoot', ['asNavBar']).component('appRoot', {
    template,
    style,
    controller($element, accountProvider, liveChatService) {
        accountProvider.getUser();

        angular.element(() => {
            liveChatService.getClientApi().then(api => {
                api.setChatButtonVisibility(false);

                let navChatButton = $element.find('#liveagent_nav_button')[0];

                api.showWhenOnline(navChatButton);

                var observer = new MutationObserver(mutationsList => {
                    for (var mutation of mutationsList) {
                        if (
                            mutation.type == 'attributes' &&
                            mutation.attributeName == 'style'
                        ) {
                            var newDisplayValue = mutation.target.style.display;

                            if (newDisplayValue === '') {
                                liveChatService.cache.isOnline = true;
                            } else if (newDisplayValue === 'none') {
                                liveChatService.cache.isOnline = false;
                            }
                        }
                    }
                });

                observer.observe(navChatButton, {
                    attributes: true,
                    childList: false,
                    subtree: false
                });
            });
        });
    }
});



// WEBPACK FOOTER //
// ./app.component.js